import React, { useCallback, useMemo } from "react"
import { SelectObjectInput, SelectObjOption } from "../../../../../../../components/inputs/select-input/SelectObjectInput"
import { BSVariantDashboardDto } from "../../../../../../../core/dto/beem-shot/BSVariant/BSVariantDashboardDto"

interface IProps {
  id: string
  label: string
  bsVariantList: BSVariantDashboardDto[]
  selectedVariant: BSVariantDashboardDto
  selectVariant(bsVariant: BSVariantDashboardDto): void
}

export function FilterVariantSelect({
  id,
  label,
  bsVariantList,
  selectedVariant,
  selectVariant,
}: Readonly<IProps>): React.JSX.Element {
  const options: SelectObjOption<BSVariantDashboardDto>[] = useMemo(
    () =>
      bsVariantList.map((bsVariant) => ({
        value: bsVariant,
        label: bsVariant.name,
      })),
    [bsVariantList]
  )

  const handleChange: (newValue: BSVariantDashboardDto | undefined) => void = useCallback(
    (newValue) => {
      if (newValue) {
        selectVariant(newValue)
      }
    },
    [selectVariant]
  )

  return (
    <SelectObjectInput
      fieldName={id}
      label={label}
      selectedOption={selectedVariant}
      options={options}
      errors={{}}
      enableNoneOption={false}
      keepNoneOptionAfterSelect={false}
      handleChange={handleChange}
      color="white"
    />
  )
}
